// src/views/sucursales/SucursalesEditView.js
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { updateSucursal, deleteSucursal } from '../../../controller/sucursalController';
import Sucursal from '../../../models/sucursal'; // Asegúrate de que esta ruta sea correcta

function SucursalesEditView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [sucursal, setSucursal] = useState(new Sucursal(location.state?.sucursal || {}));
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSucursal({
      ...sucursal,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Enviar todos los datos de la sucursal sin filtrar
    const updatedData = { ...sucursal };

    try {
      console.log(updatedData); // Aquí puedes ver los datos a enviar
      await updateSucursal(sucursal.id, updatedData);
      navigate(-1); // Regresa a la vista anterior
    } catch (error) {
      console.error('Error al actualizar la sucursal:', error);
    }
  };
  const handleDelete = async () => {
    const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar esta sucursal? Esta acción no se puede deshacer.');

    if (confirmDelete) {
      try {
        await deleteSucursal(sucursal.id);
        navigate(-1);
      } catch (error) {
        console.error('Error al eliminar la sucursal:', error);
      }
    }
  };

  return (
    <Container className="mt-4">
      <Row className="align-items-center mb-4">
        <Col><h1>Editar Sucursal</h1></Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={sucursal.name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Dirección</Form.Label>
          <Form.Control
            type="text"
            name="address"
            value={sucursal.address}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Teléfono</Form.Label>
          <Form.Control
            type="text"
            name="phone_number"
            value={sucursal.phone_number}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Correo Electrónico</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={sucursal.email}
            onChange={handleChange}
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="me-2">
          Guardar Cambios
        </Button>

        <Button variant="secondary" onClick={() => navigate(-1)} className="me-2">
          Volver
        </Button>

        <Button variant="danger" onClick={handleDelete}>
          Eliminar
        </Button>
      </Form>
    </Container>
  );
}

export default SucursalesEditView;
